import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, nothing, TemplateResult } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './ghs-contact-card.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The Contact Card component
 *
 * @element ghs-contact-card
 */
@customElement('ghs-contact-card')
export class GhsContactCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, false);

  @state() hasHeadlineSlot: boolean;
  @state() hasSubHeadlineSlot: boolean;
  @state() hasTopContentSlot: boolean;
  @state() hasBottomContentSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasHeadlineSlot = this.slots.test('contact-card-headline');
    this.hasSubHeadlineSlot = this.slots.test('contact-card-sub-headline');
    this.hasTopContentSlot = this.slots.test('contact-card-top-content');
    this.hasBottomContentSlot = this.slots.test('contact-card-bottom-content');
  }

  render(): TemplateResult {
    return html`
      <div class="contact-card">
        <div class="contact-card-top-section">
          ${
            this.hasHeadlineSlot
              ? html`
                  <div class="contact-card-headline">
                    <slot name="contact-card-headline"></slot>
                  </div>
                `
              : nothing
          }
          ${
            this.hasSubHeadlineSlot
              ? html`
                  <div class="contact-card-sub-headline">
                    <slot name="contact-card-sub-headline"></slot>
                  </div>
                `
              : nothing
          }
          ${
            this.hasTopContentSlot
              ? html`
                  <div class="contact-card-top-content">
                    <slot name="contact-card-top-content"></slot>
                  </div>
                `
              : nothing
          }
          </div>
          <div class="contact-card-bottom-section">
            ${
              this.hasBottomContentSlot
                ? html` <slot name="contact-card-bottom-content"></slot> `
                : nothing
            }
          </div>
        </div>
      </div>
    `;
  }
}
